// Add-domain route (MIS-809 / Task 28).
//
// A thin page that renders the shared AddDomainDialog open by default, so the
// /domains/new URL is shareable/bookmarkable and reuses the exact same wizard
// (form → CNAME instructions → status poll → navigate) as the list page's "Add
// Domain" button. Closing the dialog returns to the domains list.

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AddDomainDialog } from '@/components/domains/AddDomainDialog';

export const Route = createFileRoute('/_authenticated/domains/new')({
  component: NewDomainPage,
});

function NewDomainPage() {
  const navigate = useNavigate();

  return (
    <div className="p-8">
      <AddDomainDialog
        open
        onOpenChange={(open) => {
          if (!open) void navigate({ to: '/domains' });
        }}
      />
    </div>
  );
}
